import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#999"
        d="M15.471 16.562a12.3 12.3 0 0 1-4.368-1.2 13.8 13.8 0 0 1-3.796-2.715 13.6 13.6 0 0 1-2.69-3.785 12.8 12.8 0 0 1-1.2-4.354.96.96 0 0 1 .256-.766.97.97 0 0 1 .744-.325h2.176q.378 0 .65.226.273.228.38.593l.436 1.743q.05.28-.03.545a.94.94 0 0 1-.265.433L5.84 8.83q.465.872 1.03 1.641t1.24 1.439a12.5 12.5 0 0 0 3.106 2.265l1.975-1.928a.86.86 0 0 1 .4-.244q.227-.06.505-.02l1.668.368q.379.105.599.384.22.282.22.667v2.16a.95.95 0 0 1-.335.745.99.99 0 0 1-.777.255M5.353 7.772l1.57-1.506a.15.15 0 0 0 .052-.088.2.2 0 0 0-.004-.104l-.365-1.446a.17.17 0 0 0-.056-.096.16.16 0 0 0-.105-.032h-1.8a.11.11 0 0 0-.111.112q.063.792.28 1.58.215.788.539 1.58m6.958 6.91q.747.33 1.563.5.815.17 1.514.25a.11.11 0 0 0 .112-.112v-1.794a.16.16 0 0 0-.032-.105.17.17 0 0 0-.096-.056l-1.354-.293a.13.13 0 0 0-.085-.004.2.2 0 0 0-.076.052z"
      />
    </g>
  </svg>
);
export default SvgCall;
